export interface DailyNote {
  content: string
  id: string
  note_datetime: string
  parrot_id: string
}

export interface FeedingRecord {
  feeding_time: string
  food_amount_grams: number
  food_type?: string | null
  id: string
  notes?: string | null
  parrot_id: string
}

export interface HydrationRecord {
  amount_ml: number
  id: string
  parrot_id: string
  recorded_at: string
}

export interface Parrot {
  birth_date?: string | null
  gender?: string | null
  id: string
  is_owned_by_me?: boolean
  name: string
  owner_name?: string | null
  species?: string | null
}

export interface WeightRecord {
  id: string
  measured_at: string
  parrot_id: string
  weight_grams: number
}

export function dateInputValue(date = new Date()): string {
  const offset = date.getTimezoneOffset() * 60_000
  return new Date(date.getTime() - offset).toISOString().slice(0, 10)
}

export function dayRange(date: string): { end: string; start: string } {
  const start = new Date(`${date}T00:00:00`)
  const end = new Date(`${date}T23:59:59.999`)
  return { end: end.toISOString(), start: start.toISOString() }
}

export function sumBy<T>(records: T[], read: (record: T) => number): number {
  return records.reduce((total, record) => total + read(record), 0)
}

